module.exports = __webpack_public_path__ + "img/2.25a6145e.webp";